const ROOM_TYPES = Object.freeze({
  // Unlimited projects
  PROJECT_UNLIMITED: 'PRJ',
  // Pay per use Dataroom
  DATAROOM: 'PPD',
  // "Au forfait" dataroom (alternatively called "dataroom on a plan" or on a package)
  DATAROOM_UNLIMITED: 'DR',
})

export { ROOM_TYPES }
